






import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { JSONPayload } from 'avalanche/dist/utils'
import GenericPayloadView from '@/components/misc/NftPayloadView/views/GenericPayloadView.vue'

@Component({
    components: {
        GenericPayloadView,
    },
})
export default class JsonPayloadView extends Vue {
    @Prop() payload!: JSONPayload
    val = ''

    @Watch('payload')
    onPayloadChange() {
        this.updateText()
    }

    mounted() {
        this.updateText()
    }

    updateText() {
        this.val = this.jsonText
    }

    get jsonText() {
        try {
            return JSON.stringify(JSON.parse(this.text), undefined, 4)
        } catch (e) {
            return this.text
        }
    }

    get text(): string {
        return this.payload.getContent().toString()
    }

    get isGeneric() {
        try {
            return Object.prototype.hasOwnProperty.call(
                JSON.parse(this.text),
                'avalanche'
            )
                ? true
                : false
        } catch (e) {
            return false
        }
    }
}
